import "./bookingLoaders.css";

/**
 * Animated envelope with letters dropping into it. Shown while the pickup is
 * being arranged with the carrier.
 */
function BookShipmentArrangingPickupLoading() {
  return <span className="arranging-pickup-loader" />;
}

export default BookShipmentArrangingPickupLoading;
